/** translate--en */

import * as config from '../config.js';

const en = {
	key: 'en',
	MATH: {
		FRACTION: '.'
	},
	APPLY: 'continue',
	HTML: {
		title: 'Lif Configurator',
		dsTitle: 'Lif Spec Sheet'
	},
	FINISH: {
		INFO: 'Please choose your colour and click continue.',
		HEADER: 'Finish',
		seluxGraphite: 'Selux Graphite',
		ral9005: 'Jet black',
		ral7016: 'Antracite grey',
		ral7024: 'Graphite grey',
		ral7011: 'Iron grey',
		ral9007: 'Grey aluminium',
		ral9006: 'White aluminium',
		ral9010: 'Pure white',
		ral9016: 'Traffic white',
		ral6009: 'Pine green',
		ral6005: 'Moss green',
		ral5003: 'Sapphire blue',
		ral3005: 'Wine red',
		ral3003: 'Ruby red',
		db703: 'Pearled dark grey',
		db702: 'Pearled silver grey',
		db701: 'Pearled white aluminium'
	},
	STEPS: {
		FINISHED: 'ready',
		NEXT: 'next',
		scope: 'choose one or more application areas',
		config: 'configuration',
		zoom: 'configuration', // the same as config:
		parameters: 'light distribution',
		height: 'configuration height', //'height over all',
		upload: 'configuration', // the same as config:
		foto: 'picture upload',
		summary: 'summary',
		datasheet: 'finalize configuration'
	},
	// INFO: see translate-info*.js
	INFOBOX: {
		parameters: 'light distribution',
		height: 'height', //'height over all',
		element: 'element',
		inset: 'module',
		elements: 'elements',
		insets: 'modules',
		charging: 'charging station',
		chargings: 'charging stations'
	},
	SCOPE: {
		HEADING: 'Please choose one or more application areas.',
		0: 'facade',
		1: 'square',
		2: 'accentuation',
		3: 'pathway',
		length: 4
	},
	PRODUCTS: {
		baseDescription: {
			// see belowW
		},
		description: {
			// see below
		},
		datasheet: {
			// see below
		}
	},
	DATASHEET: {
		LINKTEXT: 'Finalize configuration and\ncreate spec sheet',
		SHORTDESC: 'Lif system pole',
		OPENING: 'extruded aluminium profile with die-cast aluminium terminations, ',
		FACADE: 'extruded aluminium profile with die-cast aluminium terminations, ',
		TOP: 'top elememt: PMMA, ',
		MOUNTING: 'mounting elements: can be stacked on top of one another and installed as required rotation between 0–360° to enable illumination in various directions, optionally available with a rear cover, ',
		TWINSPOT: 'twinspot module: ±45° pivotable, safety glass with polished edges, ',
		RGBW: 'accent element: PMMA, ',
		CLOSING: 'base element galvanized steel, with anti-sink plate, LED 3,000/4,000K',
		FABRICATE: 'Manufacturer: Selux, Type: SX 2006',
		COLOUR: 'Colour:',
		COLORING: 'Selux graphite or choice of colours',
		DIAMETER: 'Diameter  Ø: ',
		HEIGHT: 'Height H: ',
		WEIGHT: 'Weight: ',
		WINDAGE: 'Windage area: ',
		CONTACTINTRO: 'For further details or individual configurations, please feel free to contact us.',
		CHANGING: 'Modifications are possible due to the constant development and improvement of LED technology.',
		CHANGES: ' Subject to technical modification ',
		REQUESTPRICE: 'on request',
		HEADING_MOUNTED: 'Elements',
		HEADING_MODULES: 'Modules',
		HEADING_POLE: 'Pole',
		HEADING_ACCESSORIES: 'Accessories',
		HEADING_HEIGHT: 'Height ',
		COL_COUNT: 'Quantity',
		COL_SX: 'Order no.',
		COL_DESCRIPTION: 'Description',
		COL_SINGLE_PRICE: 'Unit*',
		COL_TOTAL_PRICE: 'Total*',
		TOTAL: 'Gross price per configuration*',
		TOTAL_HEIGHT: 'Total height',
		PRICEINFO: 'All prices are net, excluding applicable VAT and assembly.',
		LISTCAPTION: 'luminaire configuration',
		CONF_ID: 'luminaire configuration'
	},
	STELE: {
		DISTRIBUTION: 'light distribution', // Lichtverteilung
		BACKCOVER: 'optional rear cover', //Optionale Abdeckung für Rückseite
		F_WIDE: 'wide', // Breit
		F_NARROW: 'narrow', // Eng
		W_SYM: 'symmetric', // Wege Lichtverteilung
		W_ASYM: 'asymmetric', // Wege Lichtverteilung
		W_SILVER: 'silver',
		W_GOLD: 'gold',
		C_BOSCH: 'adapter plate for\nBosch FLEXIDOME IP outdoor 5000',
		C_AXIS: 'adapter plate for\nAxis Dome P322X',
		C_ENEO: 'adapter plate for\neneo dome IPD-73M2812M0A',
		RENDERING_DOWNLAOD: 'download',
		SHOW_HEAD: 'elements and modules', // TODO en: Beleuchtung
		SHOW_BOTTOM: 'pole charging station', // TODO en: Ladestation
		CHARGING_BASIC: 'Basic',
		CHARGING_ADV: 'Professional',
		CHARGING_PROF: 'Advanced',
		CHARGING_DOOR: 'Door'

	},
	FOTO: { // from Astro
		CHANGE: 'change scene',
		RESET: 'reset background',
		UPLOAD: 'upload picture',
		EDIT: 'edit picture',
		ADD: 'add luminaire',
		ACCEPT: 'change luminaire design',
		DOWNLOAD: 'download simulation'
	},
	UPLOAD: { // from Astro
		UPLOAD: 'Please select file to upload',
		UPLOADBUTTON: 'Choose File',
		ACCEPT: 'accept',
		CANCEL: 'cancel',
		ERROR: 'Error, uploading picture failed',
		WORKING: 'Uploading'
	},
	SUMMARY: {
		TITEL: 'Summary of choosen modules and their configuration',
		BASE_CONFIGURATION: 'base configuration',
		HEIGHT: 'height:',
		CABLEBOX: 'fuse box',
		EXTRADOORS: 'additional flush door',
		EXTRADOORS2: '2nd additional flush door',
		CHARGING_BASIC: 'Basic',
		CHARGING_ADV: 'Advanced',
		CHARGING_PROF: 'Professional',
		CAM: 'with adapter plate for',
		C_BOSCH: '\nBosch FLEXIDOME IP\noutdoor 5000 series',
		C_AXIS: '\nAxis dome camera P322X series',
		C_ENEO: '\neneo network dome IPD-73M2812M0A',
	},
	USER: { //TODO USER translations
		LOGIN_TEXT: 'login',
		LOGIN_BUTTON: 'login',
		LOGOUT_BUTTON: 'logout',
		USERNAME: 'user/email',
		PASSWORD: 'password',
		LOAD_TEXT: 'configuration',
		LOAD_BUTTON: 'load',
		PRICES_TEXT: 'show prices'
	}
};


// en with calculated key

en.PRODUCTS.baseDescription[config.PART_BASIS_NAME] = 'base element';
en.PRODUCTS.baseDescription[config.PART_DECKEL_NAME] = 'top cap';
en.PRODUCTS.baseDescription[config.PART_MODUL_RGBW_NAME] = 'accent element';
en.PRODUCTS.baseDescription[config.PART_MODUL_WEGE_NAME] = 'top element quadruple';
en.PRODUCTS.baseDescription[config.PART_MODUL_WEGE2_NAME] = 'top element double';
en.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_500_NAME] = 'mounting element 500';
en.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_250_NAME] = 'mounting element 250';
en.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1000_NAME] = 'mounting element 1000';
en.PRODUCTS.baseDescription[config.PART_MODUL_AUFNAHME_1500_NAME] = 'mounting element 1500';
en.PRODUCTS.baseDescription[config.PART_MODUL_KAMERA_NAME] = 'camera element';
en.PRODUCTS.baseDescription[config.PART_MODUL_WLAN_NAME] = 'WiFi element';
en.PRODUCTS.baseDescription[config.PART_ELEMENT_SPEAKER_NAME] = 'loudspeaker module';
en.PRODUCTS.baseDescription[config.PART_ELEMENT_VERT_NAME] = 'pathway module';
en.PRODUCTS.baseDescription[config.PART_ELEMENT_TWINSPOT_NAME] = 'twinspot module';
en.PRODUCTS.baseDescription[config.PART_ELEMENT_FASSADE_500_NAME] = 'facade module';
en.PRODUCTS.baseDescription[config.PART_ELEMENT_GOBO_NAME] = 'gobo module';
en.PRODUCTS.baseDescription[config.PART_MODUL_CHARGING_NAME] = 'Ladestation';

en.PRODUCTS.description[config.PART_BASIS_NAME] = 'base element';
en.PRODUCTS.description[config.PART_DECKEL_NAME] = 'top cap';
en.PRODUCTS.description[config.PART_MODUL_RGBW_NAME] = 'accent element';
en.PRODUCTS.description[config.PART_MODUL_WEGE_NAME] = 'top element\nquadruple';
en.PRODUCTS.description[config.PART_MODUL_WEGE2_NAME] = 'top element\ndouble';
en.PRODUCTS.description[config.PART_MODUL_AUFNAHME_500_NAME] = 'mounting element 500 for\ntwinspot or facade modules';
en.PRODUCTS.description[config.PART_MODUL_AUFNAHME_250_NAME] = 'mounting element 250 for\ntwinspot module';
en.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1000_NAME] = 'mounting element 1000 for\ntwinspot or facade modules';
en.PRODUCTS.description[config.PART_MODUL_AUFNAHME_1500_NAME] = 'mounting element 1500 for\ntwinspot or facade modules';
en.PRODUCTS.description[config.PART_MODUL_KAMERA_NAME] = 'camera element';
en.PRODUCTS.description[config.PART_MODUL_WLAN_NAME] = 'WiFi element';
en.PRODUCTS.description[config.PART_ELEMENT_SPEAKER_NAME] = 'loudspeaker module';
en.PRODUCTS.description[config.PART_ELEMENT_VERT_NAME] = 'pathway module';
en.PRODUCTS.description[config.PART_ELEMENT_TWINSPOT_NAME] = 'twinspot module';
en.PRODUCTS.description[config.PART_ELEMENT_FASSADE_500_NAME] = 'facade module';
en.PRODUCTS.description[config.PART_ELEMENT_GOBO_NAME] = 'gobo module';
en.PRODUCTS.description[config.PART_MODUL_CHARGING_NAME] = 'Ladestation';


export default en;
